import React from 'react'
import { Button } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'
import SeleccionCalleDeVolcado from './SeleccionCalleDeVolcado'
import ErrorIcon from '@material-ui/icons/Error'

function ConfirmarCalle (props) {
  const { cpe, datosCea, pedirConfirmacion, handleSubmit } = props

  const confirmacionChofer = (cpe && cpe.confirmacionDeChofer)
  const rechazoDeChofer = cpe && cpe.errorDescripcion && cpe.errorDescripcion === 'Rechazo de chofer'

  return (
    <>
      { ((confirmacionChofer && datosCea.cereal) || (pedirConfirmacion === 0 && datosCea.cereal))
        ? <SeleccionCalleDeVolcado
          cpe={cpe}
          cereal={datosCea.claveCereal}
          submitPesoBruto={handleSubmit}
          actualizarCalleVolcadora={props.actualizarCalleVolcadora}
          rechazarPesoBruto={props.rechazarPesoBruto}
          clearFormRechazo={props.clearFormRechazo}
          dialogOpen={props.dialogOpen}
        />
        : (!confirmacionChofer && datosCea.cereal && pedirConfirmacion === 1)
          ? (!rechazoDeChofer
            ? <div className='msj-info msj-confirmacion-calle'>
                                Esperando confirmación de chofer
            </div>
            : <>
              <div className='msj-info msj-info-rechazo-chofer'>
                <ErrorIcon style={{ color: '#ffffff', marginRight: '5px' }} />
                                    El chofer no aceptó el peso. Puede rechazarlo o volver a leer
              </div>

              <Button
                size='medium'
                style={{ margin: '2%', backgroundColor: COLORES.red.medium, color: '#ffffff', width: '96%' }}
                variant='contained'
                onClick={() => { props.rechazarPesoBruto('PESODESA') }}
              >
                                Rechazar
              </Button>
            </>
          )

          : <></>
      }
    </>

  )
}

export default ConfirmarCalle
